import * as React from "react";
const SvgFilmAdd = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M17.5 11.001V6.00065C17.5 5.06723 17.5 4.60052 17.3183 4.244C17.1586 3.9304 16.9036 3.67543 16.59 3.51564C16.2335 3.33398 15.7668 3.33398 14.8333 3.33398H5.16667C4.23325 3.33398 3.76654 3.33398 3.41002 3.51564C3.09641 3.67543 2.84144 3.9304 2.68166 4.244C2.5 4.60052 2.5 5.06723 2.5 6.00065V14.0007C2.5 14.9341 2.5 15.4008 2.68166 15.7573C2.84144 16.0709 3.09641 16.3259 3.41002 16.4857C3.76654 16.6673 4.23325 16.6673 5.16667 16.6673H10.5M5.83333 4.16732V15.834M14.1667 4.16732V11.001M2.5 6.66732H5.83333M14.1667 6.66732H17.5M2.5 13.334H5.83333M2.5 10.0007H17.5",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.334 15.832H18.334M15.834 13.332V18.332",
      stroke: "currentColor",
      strokeWidth: 1.66667,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgFilmAdd;
